/* ----------------------- scss  ------------------- */
import "./assets/scss/theme.scss";
/* ------------------------------------------ */

/* ----- Segula technologies custom scss ----- */
import "./assets/scss//SegulaTechnologies/index.scss";
import "./assets/scss//SegulaTechnologies/components/custom.scss";
import "./assets/scss//SegulaTechnologies/pages/custom.scss";

import "./assets/scss//SegulaTechnologies/theme.scss";

import "bootstrap-icons/font/bootstrap-icons.css";
/* ------------------------------------------ */

/* -------- packages -------- */
import { RouterProvider } from 'react-router-dom';
import router from './router/index';
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchParameters } from "./store/actions";
/* ------------------------- */

function App() {
  const dispatch = useDispatch();

  useEffect( () => {
    fetch('/parameters.json').then(response => response.json()).then( (data) => {
      if(data) {
        dispatch(fetchParameters(data))
      } else {
        return
      }
    }).catch((error) => {
      console.error('Parameters.json not found, error:', error)
    })
  }, [])  

  return (
      <RouterProvider router={router} />
  )
}

export default App
